module.exports = __webpack_public_path__ + "img/aprovado.0ea33041.png";